/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UserProfile } from './UserProfile'
import {
  UserProfileFromJSON,
  UserProfileFromJSONTyped,
  UserProfileToJSON,
} from './UserProfile'

/**
 *
 * @export
 * @interface GetUserProfile200Response
 */
export interface GetUserProfile200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetUserProfile200Response
   */
  status: boolean
  /**
   *
   * @type {UserProfile}
   * @memberof GetUserProfile200Response
   */
  data: UserProfile
}

/**
 * Check if a given object implements the GetUserProfile200Response interface.
 */
export function instanceOfGetUserProfile200Response(
  value: object
): value is GetUserProfile200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetUserProfile200ResponseFromJSON(
  json: any
): GetUserProfile200Response {
  return GetUserProfile200ResponseFromJSONTyped(json, false)
}

export function GetUserProfile200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetUserProfile200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: UserProfileFromJSON(json['data']),
  }
}

export function GetUserProfile200ResponseToJSON(
  value?: GetUserProfile200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: UserProfileToJSON(value['data']),
  }
}
